var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"min-height":"300","elevation":"0"}},[_c('v-card-text',[_c('v-html-editor',{model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }